<template>
  <widget title="Hot Orders">
    <template v-slot:content>
      <v-simple-table>
        <thead>
          <tr>
            <th>SO#</th>
            <th>Client</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="order in hotOrders.orders"
            :key="order.sono"
          >
            <td>
              <sales-order :sono="order.sono"></sales-order>
            </td>
            <td>
              <client-code :custno="order.custno"></client-code>
            </td>
            <td>{{ order.status }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </template>
  </widget>
</template>

<script>

import store from '@/store'
import Widget from './Widget'
import ClientCode from '../../clients/ClientCode'
import SalesOrder from '../../sales_orders/SalesOrder'

export default {
  name: 'HotOrders',
  components: {
    Widget,
    ClientCode,
    SalesOrder
  },
  data () {
    return {
      hotOrderFields: [
        {'key': 'sono', 'label': 'SO#', 'data-sono': 'sono'},
        {'key': 'custno', 'label': 'Client'},
        {'key': 'status', 'label': 'Status'}
      ]
    }
  },
  computed: {
    hotOrders () {
      return store.state.dashboard.hotOrders
    }
  },
  beforeMount () {
    store.dispatch('dashboard/fetchHotOrders')
  }
}
</script>

<style scoped>

</style>
